<script setup>
import { Calendar } from 'v-calendar';
import {ref} from "vue";

const masks = ref({
    weekdays: 'WWW'
})

const today = ref(new Date());

const attributes = ref([
    {
        key: 1,
        customData: {
            title: 'Lunch with mom.',
            class: 'bg-red-600 text-white',
        },
        dates: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    },
    {
        key: 2,
        customData: {
            title: 'Take Noah to basketball practice',
            class: 'bg-blue-500 text-white',
        },
        dates: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    },
    {
        key: 3,
        customData: {
            title: 'Take Noah to basketball practice',
            class: 'bg-blue-500 text-white',
        },
        dates: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    }
]);
</script>

<template>
    <div class="dashboard-calendar">
        <Calendar
            :attributes="attributes"
            borderless
            transparent
            disable-page-swipe
            v-model="today"
            is-expanded
        >
            <template v-slot:day-content="{ day, attributes }">
                <div class="flex flex-col h-full z-10 overflow-hidden border" style="height: 70px; width: 70px;">
                    <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
                    <div class="flex-grow overflow-y-auto overflow-x-auto">
                        <p
                            v-for="attr in attributes"
                            :key="attr.key"
                            class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                            :class="attr.customData.class"
                        >
                            {{ attr.customData.title }}
                        </p>
                    </div>
                </div>
            </template>
        </Calendar>
    </div>

</template>
<style scoped>
</style>
